import { combineReducers } from "redux";

import campaignsReducer, { initialState as campaignsInitial } from "data/campaigns";
import parentCampaignReducer, {
  initialState as parentInitial,
} from "data/parent-campaign";
import paginationReducer, { initialState as paginationInitial } from "data/pagination";

import sectionReducer, { initialState as sectionInitial } from "./parent-section";

import routesReducer, { initialState as routesInitial } from "./routes";
import votingReducer, { initialState as votingInitial } from "./voting";

export const initialState = {
  campaigns: campaignsInitial,
  routes: routesInitial,
  parentCampaign: parentInitial,
  voting: votingInitial,
  pagination: paginationInitial,
  parentSection: sectionInitial,
};

export default combineReducers({
  campaigns: campaignsReducer,
  routes: routesReducer,
  parentCampaign: parentCampaignReducer,
  voting: votingReducer,
  pagination: paginationReducer(),
  parent_section: sectionReducer,
});
